import { createContext, useEffect, useState } from "react";
import Api from "./Api";
import { User } from "./types";

type SessionContextType = {
  loading: boolean;
  user: User | null;
  login: (username: string, password: string) => Promise<boolean>;
  logout: () => void;
};

export const SessionContext = createContext<SessionContextType>({
  loading: false,
  user: null,
  login: () => Promise.resolve(false),
  logout: () => {},
});

export const SessionContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    Api.me()
      .then(setUser)
      .catch(logout)
      .finally(() => setLoading(false));
  }, []);

  const login = async (username: string, password: string) => {
    const result = await Api.login(username, password);

    if (!result.success) return false;

    localStorage.setItem("token", result.token!);
    Api.me().then(setUser);

    return true;
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
  };

  return (
    <SessionContext.Provider value={{ loading, user, login, logout }}>
      {children}
    </SessionContext.Provider>
  );
};
